import OrdersComponent from '../components/orders/orders'

const Order = () => <OrdersComponent />

export default Order;